module.exports = __webpack_public_path__ + "img/person2.1e3e96aa.webp";